import React from 'react'
import { Link } from "react-router-dom";
import { Field, reduxForm } from 'redux-form'
import Svg from '../components/Svg';

const ArtistLoginForm = ({ handleSubmit, errors, submitting, pristine, isCheckingArtist } ) => {
	//const url = 'https://casting.auditionmagic.com/ForgotPassword.aspx' //forgotpassword
	const url = '/forgotpassword' //forgotpassword
	return (
		<form id="artist-login-form" onSubmit={ handleSubmit }>
				{
					errors && <p className="error-message"><i className="fa fa-exclamation-circle"></i> {errors}</p> 
				}
				<div className="input-group">
		      <span className="input-group-label">
		      	<i className="fa fa-envelope-o"></i>
		      </span>
		      <Field 
		      	className="input-group-field" 
		      	name="username" 
		      	component="input" 
		      	type="text" 
		      	placeholder="Email" />
		    </div>

				<div className="input-group">
		      <span className="input-group-label">
			      <Svg iconName="icon-mobile-password" />
		      </span>
		      <Field 
		      	className="input-group-field" 
		      	name="password" 
		      	component="input" 
		      	type="password" 
		      	placeholder="Password" />
		    </div>

			<p className="forgot-password">Forget you password?&nbsp;
				<a className="forgot-password-link" href={url} target="_blank">click here</a>
			</p>

			<button 
				className="button primary" 
				type="submit" 
				disabled={pristine || submitting || isCheckingArtist}>
				{submitting && isCheckingArtist ? 'Logging In...' : 'LOG IN'}
			</button>
		</form>
	)
}

export default reduxForm({
  // a unique name for the form
  form: 'ArtistLoginForm'
})(ArtistLoginForm)





// WEBPACK FOOTER //
// ./src/components/ArtistLoginForm.js